const BaseFilter = require("app/components/filters/PriceFilter");
const productsApi = require("app/pipelines/products-api");

class PriceFilter extends BaseFilter {

	componentDidMount() {
		super.componentDidMount();

		productsApi.request.pipe(payload => {
			payload.$price_min = this.state.min;
			payload.$price_max = this.state.max;

			return payload;
		});
	}

	onChange(state) {
		super.onChange(state);
		productsApi.request.dispatch();
	}

}

module.exports = PriceFilter;